/*
 * @Author: Chao Yang
 * @Date: 2020-12-08 12:39:15
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-12-08 12:42:33
 */
import { Injectable } from '@angular/core';
import { IDataRoomCardCommonField } from '../../model/offering/list/i-data-room-card-common-field.model';
import { IDataRoomCard } from '../../model/offering/list/i-data-room-card.model';
import { IDataRoomCarousel } from '../../model/offering/list/i-data-room-carousel.model';
import { BaseProxy } from '../base.proxy';

@Injectable()
export class DataRoomProxy extends BaseProxy {

    GetDataRoomCards(typeId: string) {
        return this._http.get<IDataRoomCard[]>(`/ip/api/fund/data/room/cards`, {
            params: { "typeId": typeId }
        });
    }

    GetDataRoomCarousels(typeId: string) {
        return this._http.get<IDataRoomCarousel[]>(`/ip/api/fund/data/room/carousels`, {
            params: { "typeId": typeId }
        });
    }

    GetDataRoomCommonFields() {
        return this._http.get<IDataRoomCardCommonField[]>(`/ip/api/fund/data/room/fields/common`);
    }
}
